// extracted by mini-css-extract-plugin
export var wrapper = "styles-module__wrapper___qPjo2";
export var container = "styles-module__container___rCzvw";
export var signUp = "styles-module__signUp___GNGXC";
export var header = "styles-module__header___eADxD";
export var subText = "styles-module__subText___kBOLc";
export var activityCarousel = "styles-module__activityCarousel___TmVUV";